import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Form, Dropdown, Card } from 'semantic-ui-react';
import i18next from 'i18next';
import { fetchMenu, createMenu, importMenu, saveRestaurant } from '../../../actions';

class ImportMenu extends Component {
    state = { menuId: null, clone: true }

    handleSubmit = (event) => {
        const { menuId, clone } = this.state;

        if (menuId) {
            if (clone) {
                this.props.importMenu(menuId, this.props.restaurantId);
            } else {
                this.props.saveRestaurant({ id: this.props.restaurantId, menuId });
                this.props.fetchMenu(menuId);
            }
        }

        event.preventDefault();
    }

    render() {
        return (
            <div style={{ padding: 10 }}>
                <Card>
                    <Card.Content>
                        <Button basic fluid primary onClick={() => this.props.createMenu(this.props.restaurantId)}>
                            {i18next.t('menu.createMenu')}
                        </Button>
                    </Card.Content>
                    <Card.Content>
                        <Form onSubmit={this.handleSubmit} >
                            <Form.Field>
                                <Dropdown
                                    placeholder='Select Item'
                                    selection
                                    search
                                    value={this.state.menuId}
                                    options={this.props.options}
                                    onChange={(e, { value }) => this.setState({ menuId: value })}
                                />
                            </Form.Field>

                            <Form.Group inline>
                                <Form.Radio
                                    label={i18next.t('menu.importMenu')}
                                    checked={this.state.clone}
                                    onChange={() => this.setState({ clone: true })}
                                />
                                <Form.Radio
                                    label={i18next.t('menu.linkMenu')}
                                    checked={!this.state.clone}
                                    onChange={() => this.setState({ clone: false })}
                                />
                            </Form.Group>

                            <Button basic fluid primary type='submit' disabled={!this.state.menuId}>
                                {i18next.t('approve')}
                            </Button>
                        </Form>
                    </Card.Content>
                </Card>
            </div>
        );
    }
}

ImportMenu.propTypes = {
    fetchMenu: PropTypes.func,
    restaurantId: PropTypes.string,
    createMenu: PropTypes.func,
    importMenu: PropTypes.func,
    saveRestaurant: PropTypes.func,
    options: PropTypes.array,
    
};

const mapStateToProps = (state) => {
    const menuIds = [];
    const options = state.businessApp.restaurants.filter(rest => {
        const result = rest.menuId && !menuIds.includes(rest.menuId);
        menuIds.push(rest.menuId);
        return result;
    }).map(rest => ({ value: rest.menuId, text: `${rest.id} - ${rest.name} [${rest.menuId}]` }));

    return { options };
};

export default connect(mapStateToProps, { fetchMenu, createMenu, saveRestaurant, importMenu })(ImportMenu);
